"use strict";

_theme.Cart = (function(){
  // let offerConfig = JSON.parse($('.cart-template').data('config')) || null;
  let offerConfig = $('.cart-template').data('config') || null;

  function initCartEvetns(cart){
    if(cart) offerConfig.cart_total_amt = Math.floor(cart.total_price / 100);

    $(document).find("[data-block-qty] a.buttonHandler").on("click", function(e) {
      const _this = $(this);
      const $statusRegion = $('#cart-status');
      const input = _this.parent().find('input');
      let qty = parseInt(input.val());
      const isPlus = _this.hasClass('plus');

      let originalQty = input.attr('data-value');
      originalQty = originalQty ? parseInt(originalQty) : originalQty;

      let lineIndex = _this.closest(".item").attr("line-index");
      _this.parent().find('.buttonHandler').addClass('disabled');
      enableOrDisableSection(false);
      const lineIndexValue = lineIndex.match(/\d+/g);

      if(!lineIndexValue) return;

      lineIndex = lineIndexValue[0];

      if(isPlus) qty += 1;
      else qty -= 1;
      qty = qty < 0 ? 0 : qty;
      input.val(qty);

      originalQty = isPlus ? originalQty += 1 : originalQty -= 1;
      originalQty = originalQty < 0 ? 0 : originalQty;

      _theme.toggleLoading(1);
      
      if(_this.hasClass('plus')) {
        qty += 1;
        $statusRegion.text('please wait. increasing quantity');
      } else {
        qty -= 1;
        $statusRegion.text('please wait. decreasing quantity');
      }

      changeLineItemQty(lineIndex, originalQty, function(){
        _this.parent().find('.buttonHandler').removeClass('disabled');
        enableOrDisableSection(1);
        _theme.initSmartWishlist();
        _theme.toggleLoading();


        if(qty > 0){
          const $lineItemQtyBlock = $('.cart-section-items-in .cart-section-item[line-index="'+ lineIndex +'"] [data-block-qty]');
          const $statusRegion = $lineItemQtyBlock.find('[data-aria-live]');
          if(isPlus){         
            setTimeout(function() {
              $statusRegion.text('Increased successfully by 1');
            },500);
          } else {
            setTimeout(function() {
              $statusRegion.text('Decreased successfully by 1');
            },500);
          }
        }
      },0,0,_this);
    });

    $('#checkout_consent').on('change', function(evt){
      if($(this).prop('checked')){
        $('[name="checkout"]').removeAttr('disabled');
      } else {
        $('[name="checkout"]').attr('disabled', true);
      }
    });

    $('.css-1kna575,.css-esk2jp').click(function(){
      $('body').toggleClass('cm-modal-open');
    });

    $(document).on('click','button.css-1g0g0sz, .css-15jo04i',function(){
      $('body').addClass('cm-modal-open');
      var title = $(this).attr('aria-label')
      var imgUrl = $(this).attr('data-img');
      var proDes = $(this).attr('data-des');
      $('.cm-modal-img').attr('src',imgUrl).attr('alt',title);
      $('.cm-modal-title').text(title);
      $('.cm-modal-des').text(proDes);
    });

    $(document).on('change', '.cart-template .cart-section-items .item--sizelist', function(evt){
      var vid = $(this).val();
      var key = $(this).data('key');
      var qty = $(this).data('qty');
      if(!vid || !key || !qty) return;

      try {
        _theme.toggleLoading(1);
        Shopify.addItem(vid, qty, function(data){
          Shopify.removeItem(key, function(){
            _theme.toggleLoading();
            window.location.reload();
          });
        });
      } catch(err){
        console.error(err);
      }
    });

    initFreeGWP();
    initAutoFreeGift();
    initGwpModaltToggle();
  }

  function initFreeGWP(){
    const isAdded = $('.cart-section-items-in .cart-section-item[data-free-added="true"]').length > 0 ? true : false;
    if(isAdded){
      if(offerConfig.cart_total_amt < offerConfig.free_gwp_min_amount || !offerConfig.free_gwp){
        $('body').addClass('disable-free-products');
        const vid = parseInt(
          $('.cart-section-items-in .cart-section-item[data-free-added="true"]').attr('data-varid')
        );
        if(!vid) return;

        removedFreeGiftProduct(vid,0);
      } else {
        // Remove product
        $('[data-block-freegift] .cm-remove-btn').click(function(evt){
          const vid = $(this).data('varid');
          if(!vid) return;
          _theme.toggleLoading(1);
          enableOrDisableSection(false);
          removedFreeGiftProduct(vid,0);
        });
        // Update product
        $('[data-block-freegift] .cm-add-btn').click(function(evt){
          const isGiftAdded = $('.cart-section-items-in .cart-section-item[data-free-added="true"]').length > 0 ? true : false;
          if(isGiftAdded) {
            const vidNew = $(this).data('varid');
            const vidOld = parseInt($('.cart-section-items-in .cart-section-item[data-free-added="true"]').attr('data-varid'));
            if(!vidOld && vidNew) return;
    
            _theme.Helpers.changeLineItemQty(vidOld, 0, 1, function () {
              try{
                if(offerConfig.cart_total_amt >= offerConfig.free_gwp_min_amount){
                  enableOrDisableSection(false);
                  const properties = {
                    _type: 'gwp',
                    _discAmount: '0'
                  };
                  addFreeGiftProduct(vidNew,1, properties);
                }
              } catch(err){
                  console.error(err);
              }
            });
          }
        });
        // To remove the high threshold product
        if (isAdded) {
          let oldGwpId = $('.mini-products-list .regular-line-item[data-free-added="true"]').attr('data-varid');
          if(!oldGwpId) return;
      
          let oldGwpExist = $(`#basket_samples .freegiftproitem[data-varid="${oldGwpId}"]`).length > 0;
          if (!oldGwpExist) {
            _theme.Helpers.changeLineItemQty(oldGwpId, 0, 1, lineItemChangeCallBack);
          }
        }
      }
    } else {
      if(offerConfig.free_gwp && !offerConfig.auto_free_gift){
        if(offerConfig.cart_total_amt < offerConfig.free_gwp_min_amount){
          $('body').addClass('disable-free-products');
        } else {
          $('body').removeClass('disable-free-products');
        }
      }
      $('[data-block-freegift] .cm-add-btn').click(function(evt){
        const isGiftAdded = $('.cart-section-items-in .cart-section-item[data-free-added="true"]').length > 0 ? true : false;
        if(isGiftAdded) {
          _theme.toggleAjaxModal(1, 'Gift product is already added');
          return;
        }

        try{
          const config = $(this).closest('[data-block-freegift]').data('config');
          const vid = $(this).data('varid');
          if(offerConfig.cart_total_amt >= offerConfig.free_gwp_min_amount){
            enableOrDisableSection(false);
            const properties = {
              _type: 'gwp',
              _discAmount: '0'
            };
            addFreeGiftProduct(vid,1, properties);
          } else {
            _theme.toggleAjaxModal(1, 'Offer is only applicable over ' + Shopify.formatMoney(config.free_gwp_min_amount*100));
          }
        } catch(err){
          console.error(err);
        }
      });
    }
  }

  function initAutoFreeGift(){
    const isAdded = $('.cart-section-items-in .cart-section-item[data-free-gift-added="true"]').length > 0 ? true : false;
    if(isAdded){
      if(offerConfig.cart_total_amt < offerConfig.auto_free_gift_min_amount || !offerConfig.auto_free_gift){
        removedFreeGiftProduct(offerConfig.auto_free_gift_vid,0);
        // changeLineItemQty(offerConfig.auto_free_gift_vid,0, function(){
        //   window.location.href = window.location.href;
        // },1,1);
      }
    } else {
      if(!offerConfig.free_gwp && offerConfig.auto_free_gift){
        if(offerConfig.cart_total_amt >= offerConfig.auto_free_gift_min_amount){
          const properties = {
            _proType: 'freeGift',
          };
          addFreeGiftProduct(offerConfig.auto_free_gift_vid,1, properties);
        }
      }
    }
  }

  async function changeLineItemQty(line, qty, callback, disableAjax, viaId,target){
    let data = viaId ? { "quantity": qty, "id": line } : {"quantity": qty, "line": line};

    try {
      const resp = await fetch('/cart/change.js', {
        method: "post",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify(data)
      });
      const cart = await resp.json();

      if(disableAjax){
        if(callback && typeof callback === 'function') callback(cart);
      } else {
        cartMapData(cart, callback, target);
      }
    } catch (error) {
      _theme.toggleAjaxModal(1, error.message);
      if(callback && typeof callback === 'function') callback(err);

      let currentLineItem = $('.cart-section-items-in .cart-section-item[line-index="'+ line +'"]');
      if(currentLineItem.length > 0) {
        let input = currentLineItem.find("[data-block-qty] input");
        let plus = currentLineItem.find("[data-block-qty] .plus");
        input.val(qty-1);
        plus.addClass('disabled');
      }
    }
  }

  async function cartMapData(cart, callback,target){
    try {
      $('.cart-left-col .cart-section-inner').find(`.cart-section-item .cart-item-handler-in .buttonHandler`).removeClass('yellowButton');
      const resp = await fetch('/cart/?view=cart-ajax');
      const text = await resp.text();
      var parser = new DOMParser();
      var html = parser.parseFromString(text, 'text/html');
      var respBody = html.querySelector('body'); 

      $('.cart-template').attr('data-config', $(respBody).find('.cart-left-col').data('config'));
      $('.cart-left-col .cart-section-inner').html($(respBody).find('.cart-section-inner').html());
      $('.cart-left-col .freeship').html($(respBody).find('.freeship').html());
      $('.cart-right-col .freeship').html($(respBody).find('.freeship').html());
      $('.cart-right-col .order-card').html($(respBody).find('.order-card').html());
      $('.cart-right-col .free-ship-text').html($(respBody).find('.free-ship-text').html());
      if($('.cart-right-col .klarna-wrap').length) $('.cart-right-col .klarna-wrap').html($(respBody).find('.klarna-wrap').html());
      $('.cart_count').text(cart.item_count);
      $('.cart_item_text').text(cart.item_count > 1 ? 'Items' : 'Item');

      document.dispatchEvent(new CustomEvent('cart:updated', {
        detail: {
          cart: cart
        }
      }));

      let targetId;
      if(target) {
        if(target.hasClass('plus')) {
            if (cart.items_added?.[0]) {
              targetId = "plus";
              $('.cart-left-col .cart-section-inner').find(`.cart-section-item[data-varid="${cart.items_added[0].variant_id}"] .cart-item-handler-in .buttonHandler.${targetId}`).focus()
            }
        }else{
          if (cart.items_removed?.[0]) {
            targetId = "minus";
            $('.cart-left-col .cart-section-inner').find(`.cart-section-item[data-varid="${cart.items_removed[0].variant_id}"] .cart-item-handler-in .buttonHandler.${targetId}`).focus()
          }
        }
      }

      if(cart.item_count == 0){
        $('.cart_count').text("")
        const emptyCartGrid = document.querySelector('.cart_has_items.empty-cart-recommend .new-products-grid');
        if (emptyCartGrid) {
          emptyCartGrid.remove();
        }
        prodSlider();
      }
      
      initCartEvetns(cart);
      if(callback && typeof callback === 'function') callback(cart);
    } catch (error) {
      console.log(error);
      alert('Something went wrong');
    }
  }

  function addFreeGiftProduct(vid, qty, props){
    $.ajax({
      url: window.routes.cart_add_url + '.js',
      method: 'POST',
      beforeSend: function() {
        _theme.toggleLoading(1);
      },
      data: {
        quantity: qty,
        id: vid,
        properties: props
      },
      dataType: 'json',
      success:function(){
        _theme.toggleLoading();
        enableOrDisableSection(true);
        window.location.reload();
      },
      error: function(err){
        _theme.toggleAjaxModal(1, $.parseJSON(err.responseText).description);
        setTimeout(function(){
          window.location.reload();
        }, 2000);
      },
      complete: function(){
        _theme.toggleLoading();
      }
    });
  }

  function removedFreeGiftProduct(vid, qty){
    $.ajax({
      url: window.routes.cart_change_url + '.js',
      method: 'POST',
      beforeSend: function() {
        _theme.toggleLoading(1);
      },
      data: {
        quantity: qty,
        id: vid,
      },
      dataType: 'json',
      success:function(){
        _theme.toggleLoading();
        enableOrDisableSection(true);
        window.location.reload();
      },
      error: function(err){
        _theme.toggleAjaxModal(1, $.parseJSON(err.responseText).description);
        setTimeout(function(){
          window.location.reload();
        }, 2000);
      },
      complete: function(){
        _theme.toggleLoading();
      }
    });
  }

  function enableOrDisableSection(enable){
    if(enable) $('.cart-template').removeClass('processing');
    else $('.cart-template').addClass('processing');
  }

  function initGwpModaltToggle() {
    $(document).off('click', '.css-6331ag').on('click', '.css-6331ag', function () {
        const $element = $('.cart-template [data-block-freegift] #basket_samples');
        $element.toggleClass('hidden');
        const expanded = $(this).attr('aria-expanded') === 'true';
        $(this).attr('aria-expanded', !expanded);
    });
  }

  return {
    initCartEvetns: initCartEvetns,
    //changeLineItemQty: changeLineItemQty,
    cartMapData: cartMapData
  }
})();


$(function(){
  _theme.Cart.initCartEvetns();
});
function checkSmartWishlistLoaded() {
  if ($('.smartwishlist .fa-heart-o').length > 0) {
    prodSlider();
  } else {
    setTimeout(checkSmartWishlistLoaded, 100);
  }
}
function prodSlider(){
    if($(".empty-cart-recommend .new-products-grid").length){
      const $slider = $(".empty-cart-recommend .new-products-grid");

      const updateArrowState = function (slickInstance) {
        if (!slickInstance || !slickInstance.$slider) return;

        const $currentSlider = slickInstance.$slider;
        const slideCount = slickInstance.slideCount;
        const slidesToShow = slickInstance.options.slidesToShow;
        const currentIndex = slickInstance.currentSlide || 0;

        if (currentIndex === 0) {
          $currentSlider.find('.slick-prev').prop('disabled', true).addClass('slick-disabled');
        } else {
          $currentSlider.find('.slick-prev').prop('disabled', false).removeClass('slick-disabled');
        }

        if (currentIndex + Math.ceil(slidesToShow) >= slideCount) {
          $currentSlider.find('.slick-next').prop('disabled', true).addClass('slick-disabled');
        } else {
          $currentSlider.find('.slick-next').prop('disabled', false).removeClass('slick-disabled');
        }
      };

      _theme.initSlickSlider(
        $slider,
        {
          infinite: false,
          arrows:true,
          slidesToShow: 3,
          slidesToScroll: 3,
          responsive: [
            {
              breakpoint: 1440,
              settings: { 
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: false,
                dots: false
              }
            },
            {
              breakpoint: 1040,
              settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                infinite: false,
                dots: false
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1.6,
                slidesToScroll: 1,
                infinite:false
              }
            },
            {
              breakpoint: 375,
              settings: {
                slidesToShow: 1.5,
                slidesToScroll: 1,
                infinite:false
              }
            }
          ]
        },
        function (slickInstance) {
          updateArrowState(slickInstance);
        },
        function (slickInstance) {
          updateArrowState(slickInstance);
        }
      );
    }
}
checkSmartWishlistLoaded();